import { Datastore } from "util/datastore"
import { DemoSection } from "system/demo";
import { Narrow } from "component/basics";
import { channelDemoData1, channelDemoData4, channelDemoData5, channelDemoData6 } from "./channeldemo.data";
import { ChannelSelectionDropDown } from "open-modules/zdf/component/channel-dropdown";

export function ChannelSelectionDropDownDemo() {
    const roles = ["Moderator"];

    return (
        <Narrow>
            <DemoSection text={"Multiple channels & default channel available"}>
                <Datastore testState={{ modulePublic: channelDemoData1.modulePublic, serverCall: channelDemoData1.serverCall, sessionData: { personaKey: "a" }, roles }}>
                    <ChannelSelectionDropDown />
                </Datastore>
            </DemoSection>
            <DemoSection text={"Only default channel exists (not visible)"}>
                <Datastore testState={{ modulePublic: channelDemoData4.modulePublic, serverCall: channelDemoData4.serverCall, sessionData: { personaKey: "b" }, roles }}>
                    <ChannelSelectionDropDown />
                </Datastore>
            </DemoSection>
            <DemoSection text={"Multiple regular channels exist but no membership"}>
                <Datastore testState={{ modulePublic: channelDemoData5.modulePublic, serverCall: channelDemoData5.serverCall, sessionData: { personaKey: "b" }, roles }}>
                    <ChannelSelectionDropDown />
                </Datastore>
            </DemoSection>
            <DemoSection text={"Only 1 regular channel exists but no membership (not visible)"}>
                <Datastore testState={{ modulePublic: channelDemoData6.modulePublic, serverCall: channelDemoData6.serverCall, sessionData: { personaKey: "b" }, roles }}>
                    <ChannelSelectionDropDown />
                </Datastore>
            </DemoSection>
        </Narrow>
    )
}